<template>
  <div id="bio-material-step-summary">
    <section class="summary-message">
      <!-- Confirmation message, v-if successful -->
      <div v-if="!hasError && !materialRemoved" class="success">
        <img :src="checkIconSrc" alt="green check" />
        <h2 aria-live="polite">Added {{ materialLabel }} to {{ groupName }}</h2>
      </div>
      <!-- If material was removed successfully in Modify step -->
      <div v-if="!hasError && materialRemoved" class="success-info">
        <img :src="infoSrc" alt="info icon" />
        <h2 aria-live="polite">
          Removed {{ materialLabel }} from {{ groupName }}
        </h2>
      </div>
      <!-- TODO v-else other messages go here if something went wrong -->
      <div v-if="hasError" class="alert-group">
        <div class="alert">
          <img :src="alertSrc" alt="alert icon" />
          <h2 aria-live="polite">Unable to add material.</h2>
        </div>
        <ErrorStateLinks />
      </div>
    </section>
    <div class="summary-actions">
      <!-- Add Another returns to first step to add another of same material type -->
      <VButton class="primary" @click="addAnother">
        <img :src="plusSignSrc" alt="plus" />
        Add Another
      </VButton>
      <!-- If the user is in the bio wizard, close modal to return to bio wizard -->
      <VButton v-if="isInBioWizard" class="primary ghost" @click="emitDone">
        Done
      </VButton>
      <!-- If the user is OUTSIDE of bio wizard, display Associate Materials button to lead them -->
      <VButton v-else class="primary ghost" @click="openAssociateMaterialsLink">
        Associate Materials
      </VButton>
    </div>
    <div v-if="showBackButton">
      <a data-testid="back" href="" @click.prevent="backToMaterialSelect"
        >Back</a
      >
    </div>
  </div>
</template>

<script>
import VButton from "../raft/VButton.vue";
import checkIcon from "../../images/check.svg";
import plusSignIcon from "../../images/white-plus.svg";
import alertOrangeIcon from "../../images/alert_orange.svg";
import infoIcon from "../../images/info.svg";
import { useDrupalSettings } from "../../composables/useDrupalSettings";
import ErrorStateLinks from "../raft/ErrorStateLinks.vue";

const { config } = useDrupalSettings();

export default {
  name: "BioMaterialStepSummary",
  props: {
    materialLabel: { type: String, default: "Material" },
    groupNid: { type: String, required: true },
    hasError: { type: Boolean, default: false },
    materialRemoved: { type: Boolean, default: false },
    successStatus: { type: String, default: "Success" },
  },
  components: {
    VButton,
    ErrorStateLinks,
  },
  data() {
    return {
      checkIconSrc: checkIcon,
      plusSignSrc: plusSignIcon,
      alertSrc: alertOrangeIcon,
      infoSrc: infoIcon,
      destinationQuery: `node/${this.groupNid}/biologicals/bio-tracking`,
    };
  },
  computed: {
    groupName() {
      return config.groupTitle || "Group";
    },
    isInBioWizard() {
      const currentPathname = window.location.pathname;
      return !!currentPathname.includes("setup/step");
    },
    showBackButton() {
      const searchParam = window.location.search;
      return searchParam.includes("modal=");
    },
  },
  methods: {
    openAssociateMaterialsLink() {
      this.emitStatus("associate-materials");
    },
    emitDone() {
      this.emitStatus("done");
    },
    addAnother() {
      this.emitStatus("add-another");
    },
    emitStatus(status) {
      this.$emit("summary-status", { status });
    },
    backToMaterialSelect() {
      this.emitStatus("back");
    },
  },
  mounted() {
    this.$emit("change-title", this.successStatus);
  },
};
</script>

<style scoped>
#bio-material-step-summary {
  width: 100%;
  display: grid;
  grid-template-rows: 1fr max-content;
}

.summary-message {
  display: flex;
  align-items: center;
  justify-content: center;
}

.summary-message > .success,
.summary-message > .success-info {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 1.5rem;
  gap: 0.25rem;
}
.summary-message > .success > h2 {
  color: var(--green-900);
  font-weight: 400;
}
.summary-message > .success-info > h2 {
  color: var(--blue-900);
  font-weight: 400;
}
.summary-message > .alert-group {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 1.5rem;
}
.summary-message > .alert-group > .alert {
  display: flex;
  align-items: center;
  padding: 0.5rem 0;
}
.summary-message > .alert-group > .alert > h2 {
  color: var(--orange-800);
  font-weight: 400;
}
.summary-actions {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-evenly;
  padding: 1rem;
  width: 90%;
}
</style>
